(function() { window.GUID_081d6a5d_22f6_4278_a807_aa2f68f3df29 = { getGuid: function() { return "081d6a5d-22f6-4278-a807-aa2f68f3df29"; } }; })();
var CompuSport;
(function (CompuSport) {
    var Views;
    (function (Views) {
        class PromotionalMaterial {
            constructor() {
                this.bindEvents();
            }
            bindEvents() {
                $(".promotional-material-item button").offon("click.promotionalmaterialitemButton", this.downloadPromotionalMaterial.bind(this));
                $(".promotional-material-item img").offon("click.promotionalmaterialitemImage", this.showFullScreenThumbnail.bind(this));
            }
            downloadPromotionalMaterial(e) {
                const $button = $(e.currentTarget);
                const fileURL = $button.attr("value");
                if (!fileURL) {
                    return;
                }
                const link = document.createElement("a");
                link.setAttribute("href", fileURL);
                link.setAttribute("download", "compusport-promotional-material");
                link.setAttribute("target", "_blank");
                link.style.visibility = "hidden";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
            showFullScreenThumbnail(e) {
                const $img = $(e.currentTarget);
                window.open($img.attr("src"), "_blank");
            }
        }
        Views.PromotionalMaterial = PromotionalMaterial;
        new PromotionalMaterial();
    })(Views = CompuSport.Views || (CompuSport.Views = {}));
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=PromotionalMaterial.js.map
